import React, { useState } from 'react';
import {
  WorkContainer,
  WorkContent,
  WorkH1,
  WorkP,
  WorkElem,
  WorkSubtext,
  WorkSteps,
  WorkStepsIcon,
  WorkIconWrapper,
  WorkStemsNumber,
  WorkStepsTitle,
  StepsItem,
} from './Work';
import { WORK_STEPS_DATA } from '../../Data';
const Work = () => {
  //   const [hover, setHover] = useState(false);

  //   const onHover = () => {
  //     setHover(!hover);
  //   };

  return (
    <WorkContainer id="work">
      <WorkContent>
        <WorkH1>
          Мы предлагаем Вам широкий спектр возможностей в реализации Ваших идей:{' '}
        </WorkH1>
        <WorkP>
          <WorkElem>монтаж алюминиевых фасадов, окон, дверей</WorkElem>
          <WorkElem>зеркала и зеркальные панно на стены и потолки</WorkElem>
          <WorkElem>
            перегородки и входные группы из закаленного стекла
          </WorkElem>
          <WorkElem>стеклянные двери и душевые кабины</WorkElem>
          <WorkElem>стеклянные лестничные и балконные ограждения</WorkElem>
          <WorkElem>полы из стекла</WorkElem>
          <WorkElem>стеклянные козырьки</WorkElem>
        </WorkP>
        <WorkSubtext>
          Мы предоставляем свои услуги по всему Краснодарскому краю.{' '}
        </WorkSubtext>
      </WorkContent>
      <WorkSteps>
        {WORK_STEPS_DATA.map((elem, index) => (
          <StepsItem>
            <WorkIconWrapper>
              <WorkStemsNumber>{elem.step}</WorkStemsNumber>
              <WorkStepsIcon>{elem.icon}</WorkStepsIcon>
            </WorkIconWrapper>
            <WorkStepsTitle>{elem.title}</WorkStepsTitle>
          </StepsItem>
        ))}
      </WorkSteps>
    </WorkContainer>
  );
};

export default Work;
